module.exports = __webpack_public_path__ + "static/img/BenSimmons.15ab580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BenSimmons.jpg
// module id = 0t5G
// module chunks = 0